import React, { Component } from "react";
import axios from "axios";
import * as _ from "lodash";
import { authService } from "../auth";
import { convertCurrencySystem } from "../commons/CommonFunctions";

class DonationCollectedSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            donationData: {}
        }
    }

    getDonationData = () => {
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_userServiceURL}/donation/total/data?userId=${this.state.userData.userId}&entityId=${this.props.entityId}&entityType=${this.props.entityType}`,
            headers: { 'Content-Type': 'application/json' },
            withCredentials: true
        }).then(response => {
            if (response && response.data && response.data.message === 'Success!') {
                this.setState({
                    donationData: response.data.body
                })
                if(!response.data.body?.dataAvailable) {
                    this.props.hideDonationData();
                }
            }
        }).catch((err) => {
            console.log(err);
        });
    }

    componentDidMount() {
        this.getDonationData();
    }

    render() {
        const { donationData } = this.state;
        const { entityConfigData, donateNowConfig } = this.props;
        return (
            <>
                {!_.isEmpty(donationData) && donationData?.dataAvailable && 
                    <div className="prjHmDonationStatsInfo">
                        <div className="donationStatsCol">
                            <button className="btn" type="button" onClick={(e) => donateNowConfig?.id && donateNowConfig?.manageDataPermission ? this.props.changeTab("stats") : e.preventDefault()}>
                                <span>{donationData?.totalDonor}</span>
                                <h5>Donor{donationData?.totalDonor > 1 && "s"}</h5>
                                <i className="iNetwork_F" />
                            </button>
                        </div>
                        <div className="donationStatsCol">
                            <button className="btn" type="button" onClick={(e) => donateNowConfig?.id && donateNowConfig?.manageDataPermission ? this.props.changeTab("stats") : e.preventDefault()}>
                                <span><i>{entityConfigData?.indian ? <>&#8377; </> : <>&#36; </>}</i>{convertCurrencySystem(parseInt(donationData?.totalAmountCollected))}</span>
                                <h5>Amount collected</h5>
                                <i className="iWallet" />
                            </button>
                        </div>
                    </div>
                }
            </>
        )
    }
}

export default DonationCollectedSection;